import {HTTP} from '../http-common';
import discovery from '../discovery';

export default {
	// Constantes
	//TIPO:1,
	// Funciones comunes
	checkVersionHeader: function (response) {
		var version = response.headers['x-service-version'];
		if (window.$vue.$store.state.icoev.serviceVersion != version) {
			window.$vue.$store.commit('icoev/setServiceVersion', version);
			//console.log("Service version:" + version);
		}
	},
	getCommonHeaders()
	{
		var headers = {};

		headers = {
			'X-DEVICE-UUID': window.localStorage.getItem("icoev-device-uuid")
		};

		if (/MSIE|Trident/.test(window.navigator.userAgent)) {
				headers['Pragma'] = 'no-cache';
				headers['Cache-Control'] = 'no-cache, no-store';
		}

		return { headers: headers };
	},
	genericGet(service,cbok, cberr)
	{
		HTTP.get(discovery.icoev_service_url + service, this.getCommonHeaders())
			.then((response) => {
					this.checkVersionHeader(response);
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},
	genericPut (service,data,cbok, cberr)
	{
		HTTP.put(discovery.icoev_service_url + service, data, this.getCommonHeaders())
			.then((response) => {
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},
	genericPost(service,data,cbok, cberr)
	{
		HTTP.post(discovery.icoev_service_url + service, data, this.getCommonHeaders())
			.then((response) => {
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},
	genericDelete(service,cbok, cberr)
	{
		HTTP.delete(discovery.icoev_service_url + service, this.getCommonHeaders())
			.then((response) => {
					if (cbok)
						cbok(response.data);
			}).catch(function (error) {
					if (cberr)
						cberr(error);
			});
	},

	/////////////////////////////////////////////////////////////////
	//DEVICES

	storeDevice(device, cbok, cberr)
	{
		this.genericPost('devices/store', device, cbok, cberr);
	},
	enableDevicePushNotification(device, cbok, cberr)
	{
		this.genericPost('devices/enable-device-push-notifications', device, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////
	//USERS

	login(info, cbok, cberr)
	{
		this.genericPost('users/login', info, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////
	//HOME

	getHomeLatest(count, cbok, cberr)
	{
		this.genericGet('home/latests/' + count, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////
	//NEWSLETTER

	getNewsletters(page, search, cbok, cberr)
	{
		this.genericGet('newsletters/list/' + page + '?search=' + search, cbok, cberr);
	},
	clearNewslettersCache() {
		this.genericPost('newsletters/clear-cache');
	},

	/////////////////////////////////////////////////////////////////
	//ALERTS

	getAlerts(page, cbok, cberr)
	{
		this.genericGet('alerts/list/' + page, cbok, cberr);
	},
	clearAlertsCache() {
		this.genericPost('alerts/clear-cache');
	},

	/////////////////////////////////////////////////////////////////
	//CLASSIFIED

	getClassifieds(page, search, cbok, cberr)
	{
		this.genericGet('classifieds/list/' + page + '?search=' + search, cbok, cberr);
	},
	clearClassifiedsCache() {
		this.genericPost('classifieds/clear-cache');
	},

	/////////////////////////////////////////////////////////////////
	//COURSES

	getCourses(page, search, cbok, cberr)
	{
		this.genericGet('courses/list/' + page + '?search=' + search, cbok, cberr);
	},
	clearCoursesCache() {
		this.genericPost('courses/clear-cache');
	},

	/////////////////////////////////////////////////////////////////
	//CLINICS

	getClinics(numcol, cbok, cberr)
	{
		this.genericGet('clinics/list/' + numcol, cbok, cberr);
	},
	clearClinicsCache() {
		this.genericPost('clinics/clear-cache');
	},
	editClinics(data, cbok, cberr) {
		this.genericPost('clinics/edit', data, cbok, cberr);
	},

	/////////////////////////////////////////////////////////////////
	//NEWS

	getLatestNews(cbok, cberr)
	{
		this.genericGet('content/news', cbok, cberr);
	},

}
